import { Grid, Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Button } from '@roc/ui';
import { observer } from 'mobx-react';
import { WireInstructionsLoanDetailsCard } from './wireInstructionsLoanDetailsCard';
import { WireInstructionsStore } from '../stores/wireInstructionsStore';

const useStyles = makeStyles((theme: Theme) => ({
  leftColumn: {
    padding: theme.spacing(8, 6),
  },
  rightColumn: {
    padding: theme.spacing(8, 6),
  },
  hello: {
    ...theme.typography.h4,
    fontSize: 48,
  },
  text: {
    padding: theme.spacing(4, 0),
  },
  button: {
    fontWeight: 'normal',
    padding: theme.spacing(2, 8),
  },
}));

interface Props {
  store: WireInstructionsStore;
  onStart: () => void;
}

export const WelcomeStep = observer(({ store, onStart }: Props) => {
  const classes = useStyles();
  const { loanData } = store;

  return (
    <Grid container>
      <Grid item md={12} lg={6} className={classes.leftColumn}>
        <Typography className={classes.hello}>
          Hello {loanData?.contactName || 'there'}!
        </Typography>
        <Typography className={classes.text}>
          Please review the wire fraud notice, fill in your bank information, and
          sign to complete. This should only take a few minutes.
        </Typography>
        <Button
          testId="get-started"
          variant="contained"
          color="primary"
          className={classes.button}
          disabled={!loanData}
          onClick={onStart}
        >
          GET STARTED
        </Button>
      </Grid>
      <Grid item xs={12} md={12} lg={6} className={classes.rightColumn}>
        <WireInstructionsLoanDetailsCard loanData={loanData} />
      </Grid>
    </Grid>
  );
});
